// @mui
import { alpha, styled } from "@mui/material/styles";
import { ListItemIcon, ListSubheader, ListItem } from "@mui/material";
// config
import { ICON, NAV } from "../../../config";

// ----------------------------------------------------------------------

export const StyledItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== "active" && prop !== "caption",
})(({ theme }) => {
  const isLight = theme.palette.mode === "light";
  return {
    position: "relative",
    textTransform: "capitalize",
    color: "#BCBCBC",
    borderRadius: theme.shape.borderRadius,
    height: NAV.H_DASHBOARD_ITEM,
    paddingLeft: "33px",

    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: "#FFFFFF",
      //  width: "150px",
      borderTopRightRadius: "10px",
      borderBottomRightRadius: "10px",
      cursor: "pointer",
    },
    "&:active": {
      backgroundColor: theme.palette.secondary.main,
      // width: "150px",
      borderTopRightRadius: "15px",
      borderBottomRightRadius: "15px",
    },
  };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled(ListItemIcon)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: ICON.NAV_ITEM,
  height: ICON.NAV_ITEM,
  marginRight: "16px",
  color: "#FFFFFF",
});

// ----------------------------------------------------------------------
